var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.21484 2.1875H13.2148C13.4635 2.1875 13.7019 2.28627 13.8778 2.46209C14.0536 2.6379 14.1523 2.87636 14.1523 3.125V5.9375H16.9648C17.2135 5.9375 17.4519 6.03627 17.6278 6.21209C17.8036 6.3879 17.9023 6.62636 17.9023 6.875V16.875C17.9023 17.1236 17.8036 17.3621 17.6278 17.5379C17.4519 17.7137 17.2135 17.8125 16.9648 17.8125H6.96484C6.7162 17.8125 6.47775 17.7137 6.30193 17.5379C6.12612 17.3621 6.02734 17.1236 6.02734 16.875V14.0625H3.21484C2.9662 14.0625 2.72775 13.9637 2.55193 13.7879C2.37612 13.6121 2.27734 13.3736 2.27734 13.125V3.125C2.27734 2.87636 2.37612 2.6379 2.55193 2.46209C2.72775 2.28627 2.9662 2.1875 3.21484 2.1875ZM7.90234 15.9375H16.0273V7.8125H7.90234V15.9375ZM4.15234 12.1875H6.02734V6.875C6.02734 6.62636 6.12612 6.3879 6.30193 6.21209C6.47775 6.03627 6.7162 5.9375 6.96484 5.9375H12.2773V4.0625H4.15234V12.1875Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.8671c2ea383b6b80742315b771fc8eee.svg";